import React from 'react';
import { Checkbox } from './ui/checkbox';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

interface DataTableSelectAllCheckboxProps {
  checked: boolean | 'indeterminate';
  onCheckedChange: (checked: boolean) => void;
  label: string;
}

export const DataTableSelectAllCheckbox: React.FC<DataTableSelectAllCheckboxProps> = ({
  checked,
  onCheckedChange,
  label,
}) => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Checkbox
            checked={checked}
            onCheckedChange={(value) => onCheckedChange(!!value)}
            aria-label={label}
            onClick={(event) => event.stopPropagation()}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
